module.exports = __webpack_public_path__ + "static/olive-again-46781d05dc6634919b888ffccd39833f.jpg";